const isInViewport = (node: Element, offset: number = 0) => {
    if (!node) return false;
    const top = node.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
};

export default isInViewport;